import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';

import CheckboxIcon from '../icons/CheckboxIcon';
import InputErrors from '../common/InputErrors';
import LoadingButton from '../common/LoadingButton';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      staySignedIn: false,
      isLoading: false,
      serverErrors: [],
    };
  }

  login = (e) => {
    e.preventDefault();
    this.setState({
      serverErrors: [],
      isLoading: true,
    });
    this.props.usersActions.login(
      this.state.email,
      this.state.password,
      this.state.staySignedIn,
      this.onFail,
    );
  }

  onFail = (error) => {
    console.log({...error})
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
      isLoading: false,
    });
  }

  handleInputChange = ({ target }) => {
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ [name]: value });
  }

  render() {
    return this.props.loggedIn ? (
      // After login, redirect to original destination or default to the dashboard
      <Redirect to={this.props.location.state
        ? this.props.location.state.from.pathname + this.props.location.state.from.search
        : '/'} />
    ) : (
      <Fragment>
        <Helmet>
          <title>Login</title>
        </Helmet>
        <div className="fullscreen-form fullscreen-form--blue">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading fullscreen-form__heading--extra-margin">
              Welcome
            </h1>
            <form className="form fullscreen-form__form">
              {this.state.serverErrors.length !== 0 && <InputErrors errors={this.state.serverErrors} />}
              <label htmlFor="email">
                Email
              </label>
              <input
                name="email"
                id="email"
                value={this.state.email}
                onChange={this.handleInputChange}
                type="email"
              />
              <label htmlFor="password">
                Password
              </label>
              <input
                name="password"
                id="password"
                value={this.state.password}
                onChange={this.handleInputChange}
                type="password"
              />
              <div className="fullscreen-form__options">
                <Link to='/forgot-password' className="flat-link">
                  Forgot password?
                </Link>
                <label className="fullscreen-form__checkbox">
                  <input
                    name="staySignedIn"
                    type="checkbox"
                    value={this.state.staySignedIn}
                    onChange={this.handleInputChange}
                  />
                  <CheckboxIcon value={this.state.staySignedIn} reversed />
                  Stay signed in
                </label>
              </div>
              <div className="fullscreen-form__button-wrapper">
                <LoadingButton
                  text="Log In"
                  onClick={this.login}
                  loading={this.state.isLoading}
                />
                <br />
                <Link to="/register" className="flat-link">
                  Don't have an account? Create yours here
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { usersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js